module.exports = __webpack_public_path__ + "static/media/delivery.fee798d1.svg";